import { render, staticRenderFns } from "./GerenciarElementosPrimariosGenericos.vue?vue&type=template&id=40c096dd&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarElementosPrimariosGenericos.vue?vue&type=style&index=0&id=40c096dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c096dd",
  null
  
)

export default component.exports